import { InjectionToken } from '@angular/core';
import { AuthConfig } from 'angular-oauth2-oidc';

export const PING_IDENTITY_CONFIG = new InjectionToken<AuthConfig>('PING_IDENTITY_CONFIG');
